import React, { useState } from 'react';
// import { Box, TextField, IconButton, Typography, Paper, Button, Grid, Pagination } from '@mui/material';
import { Box, TextField, IconButton, Typography, Paper, Button, Grid, Pagination  } from '@barracuda-internal/bds-core';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const PAGE_SIZE = 20;

function jsonToCsv(jsonData) {
  if (!Array.isArray(jsonData) || jsonData.length === 0) {
    return ""; // Return empty string for invalid input
  }

  // Extract headers from the keys of the first object
  const headers = ["host","ip"];

  // Create the header row for the CSV
  const headerRow = headers.join(',');

  // Map each JSON object to a CSV row
  const rows = jsonData.map(obj => {
    return headers.map(header => {
      let value = obj[header];
      // Handle potential null/undefined values and escape commas/quotes
      if (value === null || value === undefined) {
        value = "";
      } else if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
        // Enclose in double quotes and escape existing double quotes
        value = `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    }).join(',');
  });

  // Combine headers and rows
  return [headerRow, ...rows].join('\r\n'); // Use \r\n for cross-platform newlines
}

export default function SubDomains({ subdomains }) {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const filtered = search
    ? subdomains.filter(d => d.host.toLowerCase().includes(search.toLowerCase()))
    : subdomains;
  const pageCount = Math.ceil(filtered.length / PAGE_SIZE);
  const startIdx = (page - 1) * PAGE_SIZE;
  const currentPageDomains = filtered.slice(startIdx, startIdx + PAGE_SIZE);
  const half = Math.ceil(currentPageDomains.length / 2);
  const col1 = currentPageDomains.slice(0, half);
  const col2 = currentPageDomains.slice(half);

const handleCopy = (value) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(value);
    } else {
      // fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = value;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
  };

  return (
    <Box sx={{ width: '100%', mx: 'auto', mt: 3 }}>
      <Typography variant="h5" gutterBottom>
        Subdomains ({filtered.length})
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          label="Search subdomains"
          variant="outlined"
          size="small"
          sx={{ flex: 1 }}
          value={search}
          onChange={e => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
        <Button
          bdsType="interactiveNeutral"
          onClick={() => {
            const csv = jsonToCsv(filtered);
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'subdomains.csv';
            a.click();
            URL.revokeObjectURL(url);
          }}
        >
          Export CSV
        </Button>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          {col1.map((domain, idx) => (
            <Paper key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1, pl: 1, gap: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>{domain?.host}</Typography>
                <Typography variant="caption" color="text.secondary">{domain?.ip || 'No IP'}</Typography>
              </Box>
              <IconButton
                size="small"
                onClick={() => handleCopy(domain?.host)}
                title="Copy Host"
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Paper>
          ))}
        </Grid>
        <Grid item xs={12} sm={6}>
          {col2.map((domain, idx) => (
            <Paper key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1, pl: 1, gap: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>{domain?.host}</Typography>
                <Typography variant="caption" color="text.secondary">{domain?.ip || 'No IP'}</Typography>
              </Box>
              <IconButton
                size="small"
                onClick={() => handleCopy(domain?.host)}
                title="Copy Host"
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Paper>
          ))}
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Pagination
            itemsPerPage={PAGE_SIZE}
            itemsPerPageDescription="items per page"
            // itemsPerPageOptions={[
            //     10,
            //     20,
            //     50
            // ]}
            onChange={(_, value) => setPage(value)}
            onClickItemsPerPage={function noRefCheck(){}}
            onClickItemsPerPageOption={function noRefCheck(){}}
            onCloseItemsPerPage={function noRefCheck(){}}
            page={page}
            totalItems={filtered.length}
        />
      </Box>
    </Box>
  );
}
